<template>
  <div id="inskin" style="background-color:white;" v-show="!loaded">
    <div class="ucf-leftside-ad">
      <a :href="creative.landing_page" target="_blank">
        <img class="side-ad" :src="creative.left_image_url" @load="onLoad" />
      </a>
    </div>

    <div class="ucf-rightside-ad">
      <a :href="creative.landing_page" target="_blank">
        <img class="side-ad" :src="creative.right_image_url" @load="onLoad" />
      </a>
    </div>

    <div
      :style="{ height: creative.top_image_height + 'px' }"
      style="overflow:hidden;"
    >
      <a :href="creative.landing_page" target="_blank">
        <div
          class="ucf-banner-ad"
          :style="{
            backgroundImage: 'url(' + creative.top_image_url + ')',
            height: creative.top_image_height + 'px',
          }"
        ></div>
      </a>
    </div>

    <div id="ucf-middle-ad">
      <table>
        <tr>
          <td align="center">
            <img
              :src="isamnet"
              style="width:100%"
              @load="onLoad"
            />
          </td>
        </tr>
      </table>
    </div>

    <div
      class="ucf-footer-ad"
      :style="{ height: creative.bottom_image_height + 'px' }"
    >
      <a :href="creative.landing_page" target="_blank">
        <img
          class="footer-ad"
          :src="creative.bottom_image_url"
          @load="onLoad"
        />
      </a>
    </div>
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
export default {
  data() {
    return {
      loaded: 4,
      intervalEvent: null,
    };
  },
  async mounted() {
    await this.$nextTick();
    setTimeout(function() {
      document.querySelector(".ucf-banner-ad").scrollIntoView();
    }, 100);
    this.intervalEvent = setInterval(this.setLayout, 100);
    this.addEvent(window, "scroll", this.handleScroll);
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if(domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/inskin-bg.png'
      } else {
        isAmnet += '/inskin/bg.png'
      }
      return isAmnet
    }
  },
  mixins: [mixPreview],
  methods: {
    setLayout() {
      var leftSideWidth = document
        .querySelector(".ucf-leftside-ad")
        .getBoundingClientRect().width;
      var rightSideWidth = document
        .querySelector(".ucf-rightside-ad")
        .getBoundingClientRect().width;

      if (leftSideWidth * rightSideWidth) {
        var sideWidth = (100 - this.creative.content_width) / 2;
        document.querySelector("#ucf-middle-ad").style.width =
          this.creative.content_width + "%";
        document.querySelector(".ucf-leftside-ad").style.left =
          "calc( " + sideWidth + "% - " + leftSideWidth + "px)";
        document.querySelector(".ucf-rightside-ad").style.right =
          "calc( " + sideWidth + "% - " + rightSideWidth + "px)";
        clearInterval(this.intervalEvent);
      }
    },
    handleScroll() {
      if (
        window.innerHeight + window.scrollY >=
        document.body.scrollHeight * 0.6
      ) {
        var scrolling = setInterval(() => {
          if (
            window.innerHeight + window.scrollY >=
            document.body.scrollHeight
          ) {
            clearInterval(scrolling);
          } else {
            document
              .querySelector(".ucf-footer-ad")
              .scrollIntoView({ block: "end", behavior: "smooth" });
          }
        }, 500);
        this.removeEvent(window, "scroll", this.handleScroll);
      }
    },
  },
};
</script>
<style lang="sass" scoped>
body
  margin: 0px
.ucf-leftside-ad
  position: fixed
  left: -100vh
  z-index: 1
  img
    float: right

.ucf-rightside-ad
  position: fixed
  right: -100vh
  z-index: 1
  img
    float: left

.ucf-banner-ad
  background-attachment: fixed
  background-repeat: no-repeat
  background-position: center top

#ucf-middle-ad
  margin: auto
  table
    width: 100%

.ucf-footer-ad
  position: relative
  overflow: hidden
  img
    position: absolute
    top: 0px
    left: 50%
    transform: translateX(-50%)
</style>
